import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

const responseSchema = z.object({
	isSuccess: z.boolean(),
});

const getMemberValidationStatus = (options: APIFactoryOptions, timeout: number) =>
	factory(options).createAPIDefinition({
		url: '/Member/:encryptedJourneyId/GetMemberValidationStatus',
		method: 'GET',
		responseSchema,
		requestParameters: { encryptedJourneyId: ['required', 'string'] },
		timeout,
		errorCodes: [
			'InvalidDataError',
			'TimeoutError',
			'TechnicalError',
			'DataEntryError',
			'InvalidMemberData',
			'PendingUnPaidFines',
			'InvalidVisaEmirateSelection',
			'BlackListedMember',
			'SanctionedMember',
			'PolicyDetailsNotFound',
			'EffectiveDateExceedValidationDate',
			'ApiTimeOut',
			'InvalidVisaNumber',
			'InvalidQuoteEmirateToVisaFileNumber',
		],
	});

export type GetMemberValidationStatusResponse = TypeOfAPIResponse<ReturnType<typeof getMemberValidationStatus>>;

export type GetMemberValidationStatusError = TypeOfAPIError<ReturnType<typeof getMemberValidationStatus>>;

export default getMemberValidationStatus;
